import type { NavigationGuardNext, RouteLocationNormalized, RouteLocationNormalizedLoaded } from "vue-router";

const langs = ["ru", "uk"] as const;
type Locale = (typeof langs)[number];

export const legacyRoutes = ["/", "/index", "/about", "/actual", "/help"];

const getLegacyLocale = (path: string): Locale | null => {
    const parts = path.split("/").filter(Boolean);
    const first = parts[0];
    return langs.includes(first as Locale) ? (first as Locale) : null;
};

const stripLegacyLocale = (path: string): string => {
    const locale = getLegacyLocale(path);
    if (!locale) return path;

    const prefix = `/${locale}`;
    const result = path.startsWith(prefix) ? path.slice(prefix.length) : path;
    return result || "/";
};

export const beforeEachLegacy = (to: RouteLocationNormalized, from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) => {
    const locale = getLegacyLocale(to.path);
    const normalizedPath = stripLegacyLocale(to.path);

    if (locale && legacyRoutes.includes(normalizedPath)) {
        next({ path: "/legacy", state: { lang: locale } });
        return;
    }

    next();
};
